import KeplerSdk from './../../keplerSdk.js'

const state = {
    reservations: [],
    reservationsLastFetch: null,
}

const mutations = {
    SET_RESERVATION_LIST (state, message) {
        state.reservations = message
    },
    SET_RESERVATION_LAST_FETCH (state, message) {
        state.reservationsLastFetch = message
    },
}

const actions = {
    fetchReservations: ({commit}, payload) => {
        if (state.reservationsLastFetch == null) {
            KeplerSdk.reservationList(function (data) {
                commit('SET_RESERVATION_LAST_FETCH', Math.floor(Date.now() / 1000))
                commit('SET_RESERVATION_LIST', data)
            }, function (error) {

            })
        }
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/frontoffice/reservationsStore.js